
import React from 'react'

export class Currency extends React.Component {
    render() {
      return <span>&#8377;</span>
    }
}



// WEBPACK FOOTER //
// ./src/utils/currency.js